const env = {
    // urlBackend: "http://localhost:8000"
    urlBackend: "https://backend.data24-7gaming.com"
    // urlBackend: "https://backend-gli.data24-7gaming.com"
    // urlBackend: "http://192.168.80.20:8000" 
}   
export default env;
